<div class="align-items-start flex-nowrap" [ngClass]="{ 'input-group': props.addonLeft || props.addonRight }">
  @if (props.addonLeft) {
  <div class="input-group-prepend">
    <span class="input-group-text symbol-alignment-field">{{ addonLeftText | async | translate }}</span>
  </div>
  }
  <div class="flex-grow-1"><ng-container #fieldComponent /></div>
  @if (props.addonRight) {
  <div class="input-group-append">
    <span class="input-group-text symbol-alignment-field">{{ addonRightText | async | translate }}</span>
  </div>
  }
</div>
